import React from "react";

import classNames from "classnames";
import { DoorIconProps } from "../doorOptions/DeKaap";

export const DeBeurs: React.FC<DoorIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width={29}
      height={60}
      viewBox="0 0 28 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("gg-transition gg-ease-in-out gg-duration-150", {
        "gg-fill-[#292747]": isActive,
        "gg-fill-[#9493A3]": !isActive,
      })}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M25.637 2H2.364v56h23.273zM.364 0v60h27.273V0z" />
        <path d="M1.273 44h26v-1h-26zm0-27h26v-1h-26z" />
      </g>
    </svg>
  );
};
